import React, { useContext } from "react";
import "../css/editblog.css";
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import uiContext from "../context/ui/uiContext";
function BlogList(props) {
  const history = useHistory();
  const context=useContext(uiContext);
  const dashContext=useContext(uiContext);
  const deleteBlog = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}blog/deleteblog?id=${props.id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            "auth-token": localStorage.getItem("auth-token"),
          },
        }
      );
      const data = await response.json();
      if (!data.success) {
        return toast.error("Could Not delete Currently");
      }
      toast.info("Deleted!!");
      history.push("/dashboard/myaccount");
    } catch (error) {
      console.log(error);
    }
  };

  const editBlog =() => {
    context.setToEdit(()=>{
     return { id:props.id}
    });
    context.setEditModal((prev)=>{
      return prev?false:true;
    })
    dashContext.setDashNav(0);
  };
  return (
    <>
      <ToastContainer />
      <div className="bloglistcontainer">
        <div className="blogdatabox">
          <h4>{props.title}</h4>
          <h5>{props.slug}</h5>
        </div>
        <button onClick={editBlog}>Edit</button>
        <button onClick={deleteBlog}>Delete</button>
      </div>
    </>
  );
}

export default BlogList;
